import { Tooltip } from "antd";

import { CircleArrowUp, CircleArrowDown, CircleEqual, IconMessageQuestion } from "../components/Icons";
import BaseCard from "./BaseCard";
import { __ } from "../locales/translation";
import Variation, { VariationBig } from "./Variation";

export default function CardWithTooltip({ variacion, label, buyPrice, sellPrice, tooltipText }) {
    // const variationMap = {
    //     up: <CircleArrowUp />,
    //     down: <CircleArrowDown />,
    //     none: <CircleEqual />,
    // };

    let variationType;

    if (variacion > 0) {
        variationType = "up";
    }

    if (variacion < 0) {
        variationType = "down";
    }

    if (variacion === 0) {
        variationType = "none";
    }

    return (
        <BaseCard classNames="cot-card-with-tooltip">
            {/* <div className="var-icon">{variationMap[variationType]}</div> */}

            <div className="title-wrapper">
                <h5 className="title-5 title">{label}</h5>

                <div className="values-container">
                    <div className="value-wrapper">
                        <span className="tag label">{__("Compra")}</span>
                        <p className="paragraph value">{sellPrice}</p>
                    </div>

                    <div className="value-wrapper">
                        <span className="tag label">{__("Venta")}</span>
                        <p className="paragraph value">{buyPrice}</p>
                    </div>
                </div>
            </div>

            <div className="variation-tooltip">
                <Variation value={variacion} />
                {/* <p className={`title-5 --variation-${variationType}`}>{variacion}%</p> */}

                {tooltipText && (
                    <Tooltip title={tooltipText} placement="bottomRight" color="#fff" className="tooltip">
                        <span>
                            <IconMessageQuestion />
                        </span>
                    </Tooltip>
                )}
            </div>
        </BaseCard>
    );
}
